import { api } from './client';

export const capturesApi = {
  // Story-scoped captures
  listStory: (storyId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.type) queryParams.append('type', params.type);
    if (params.label_ids && params.label_ids.length > 0) {
      params.label_ids.forEach(id => queryParams.append('label_ids', id));
    }
    if (params.label_match) queryParams.append('label_match', params.label_match);
    if (params.parked !== undefined && params.parked !== null) queryParams.append('parked', params.parked);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    const queryString = queryParams.toString();
    return api.get(`/stories/${storyId}/captures${queryString ? `?${queryString}` : ''}`);
  },
  
  createStory: (storyId, content, captureType = 'todo') =>
    api.post(`/stories/${storyId}/captures`, {
      content,
      capture_type: captureType
    }),

  // Project-scoped captures
  listProject: (projectId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.type) queryParams.append('type', params.type);
    if (params.label_ids && params.label_ids.length > 0) {
      params.label_ids.forEach(id => queryParams.append('label_ids', id));
    }
    if (params.label_match) queryParams.append('label_match', params.label_match);
    if (params.parked !== undefined && params.parked !== null) queryParams.append('parked', params.parked);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    const queryString = queryParams.toString();
    return api.get(`/projects/${projectId}/captures${queryString ? `?${queryString}` : ''}`);
  },
  
  createProject: (projectId, content, captureType = 'todo') =>
    api.post(`/projects/${projectId}/captures`, {
      content,
      capture_type: captureType
    }),

  // Capture operations
  get: (captureId) => api.get(`/captures/${captureId}`),
  
  update: (captureId, updates) => api.patch(`/captures/${captureId}`, updates),
  
  delete: (captureId) => api.delete(`/captures/${captureId}`),
  
  reorder: (captureId, afterId, beforeId) =>
    api.post(`/captures/${captureId}/reorder`, {
      after_id: afterId,
      before_id: beforeId
    }),
    
  // payload: { session_name, guidance_mode, template, focus_target_name, custom_focus_id }
  spawnSession: (captureId, payload) =>
    api.post(`/captures/${captureId}/spawn-session`, payload)
};
